import { render, staticRenderFns } from "./XToDosFilters.vue?vue&type=template&id=4080edc1&scoped=true&"
import script from "./XToDosFilters.vue?vue&type=script&lang=ts&"
export * from "./XToDosFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080edc1",
  null
  
)

export default component.exports